import mentalHealthImage from "@/assets/mental-health-image.webp";

export const LandingInfo = () => {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[695px] flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 lg:gap-20 pt-12 md:pt-16 pb-16 md:pb-20 lg:pb-24 px-6 md:px-12 lg:px-16 overflow-hidden">
      {/* Aqueous Background with Gradient */}
      <div className="absolute inset-0 bg-gradient-to-tr from-white via-[#FFD166]/5 to-[#D8DEE9]/15 -z-10"></div>

      {/* Floating Blobs */}
      <div
        className="absolute top-20 right-[10%] w-[500px] h-[500px] rounded-full opacity-15 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(255, 209, 102, 0.5) 0%, rgba(255, 209, 102, 0) 70%)",
          animation: "float 22s ease-in-out infinite",
        }}
      ></div>
      <div
        className="absolute bottom-32 left-[5%] w-[400px] h-[400px] rounded-full opacity-10 blur-3xl -z-10"
        style={{
          background: "radial-gradient(circle, rgba(74, 78, 105, 0.4) 0%, rgba(74, 78, 105, 0) 70%)",
          animation: "float 28s ease-in-out infinite reverse",
        }}
      ></div>

      <div
        className="flex-shrink-0 hidden md:block relative"
        style={{
          animation: "fadeInScale 0.8s ease-out",
        }}
      >
        {/* Glow ring around image */}
        <div
          className="absolute -inset-6 rounded-full opacity-20 blur-2xl -z-10"
          style={{
            background:
              "conic-gradient(from 0deg, rgba(255, 209, 102, 0.6), rgba(74, 78, 105, 0.4), rgba(255, 209, 102, 0.6))",
            animation: "rotate 10s linear infinite",
          }}
        ></div>

        <div className="relative group">
          <img
            src={mentalHealthImage}
            alt="Pessoa encontrando equilíbrio e clareza mental através da terapia cognitivo-comportamental"
            width="348"
            height="339"
            className="w-64 md:w-[348px] h-auto"
          />
        </div>
      </div>

      <div className="flex-1 max-w-[664px] space-y-8 md:space-y-12">
        {/* First Block - No animation delay to improve LCP */}
        <div className="space-y-4">
          <h2 className="text-2xl sm:text-3xl md:text-3xl font-bold text-[#4A4E69] leading-tight">
            Cansado da sobrecarga mental?
          </h2>
          <p className="text-base md:text-lg text-[#272D37]/80 leading-relaxed relative pl-4 border-l-4 border-[#FFD166]/40">
            Viver com um ruído mental de pensamentos automáticos e negativos é exaustivo. Aquela sensação de que sua
            mente não para? Os mesmos pensamentos negativos em loop, te deixando exausto(a) e sem foco? Você não está
            sozinho(a). Esse ruído mental não precisa controlar o seu dia.
          </p>
        </div>

        {/* Second Block - No animation delay to improve LCP */}
        <div className="space-y-4">
          <h2 className="text-2xl sm:text-3xl md:text-3xl font-bold text-[#4A4E69] leading-tight">
            Sua jornada para a clareza começa aqui.
          </h2>
          <p className="text-base md:text-lg text-[#272D37]/80 leading-relaxed relative pl-4 border-l-4 border-[#FFD166]/40">
            Mais que um chat, desenvolvida por especialistas, a IA da KopfAI é baseada em lógica clinicamente validada e
            monitorada para qualidade e segurança. Através de uma conversa empática a IA ajuda você a identificar,
            desafiar e reestruturar padrões de pensamento ruins. A IA não dá respostas prontas; ela ajuda você a
            encontrar as suas.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { 
            transform: translate(0, 0) scale(1); 
          }
          50% { 
            transform: translate(40px, 40px) scale(1.15); 
          }
        }
        
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </section>
  );
};
